export interface IconStyle {
  bg?: string;
  color?: string;
  disabled?: IconStyle;
}

export interface ButtonStyle {
  bg?: string;
}
